var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSeelessTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.334 8.5A6.674 6.674 0 018 1.833 6.674 6.674 0 0114.667 8.5 6.674 6.674 0 018 15.166 6.674 6.674 0 011.334 8.5",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.187 9.461c0-.127.049-.255.146-.352l2.313-2.325a.501.501 0 01.709 0l2.315 2.325a.5.5 0 11-.71.705L8 7.845 6.04 9.814a.5.5 0 01-.853-.353",
    fill: "#333"
  })));
}

export default SvgIconSeelessTask;